interface ReceiptViewInterface {
  id: string
  elementId: string
  title: string
  type: string
  signedDocument: boolean
  scope: string
  receiptTypeId: string

}

class ReceiptView implements ReceiptViewInterface {
  constructor(
    public id: string,
    public elementId: string,
    public title: string,
    public type: string,
    public signedDocument: boolean,
    public scope: string,
    public receiptTypeId: string
  ) {
    this.id = id
    this.elementId = elementId
    this.title = title
    this.type = type
    this.signedDocument = signedDocument
    this.scope = scope
    this.receiptTypeId = receiptTypeId
  }
}

type ReceiptViewGroupedByType = {
  [type: string]: ReceiptViewInterface[];
};

type ReceiptViewGroupedByScope = {
  [scope: string]: ReceiptViewGroupedByType
};

export type {ReceiptViewInterface, ReceiptViewGroupedByType, ReceiptViewGroupedByScope}

export {
  ReceiptView
}
